<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="title"
    width="30%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
      >
        <el-form-item
          label="考试费用"
          prop="fee"
        >
          <el-input
            v-model="createForm.fee"
          />
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';

export default {
  name: 'UpsertExamFeeDialog',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      title: '设置考试金额',
      cancelText: '取消',
      courseList: [],
      createForm: {
        fee: null,
      },
      creatRules: {
        fee: [
          { required: true, message: '请输入考试费用', trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        const {
          fee,
        } = this.item;
        this.createForm = {
          fee: fee / 100,
        };
        this.$nextTick(() => {
          this.$refs.createForm.clearValidate();
        });
      }
    },
  },
  mounted() {
    console.log(this.createForm);
  },
  methods: {
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          this.$emit('confirm', Number(this.createForm.fee) * 100);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
  .wx-info {
    padding: 0 0 0 0;
    text-align: left;
    .item {
      margin-bottom: 15px;
      span {
        font-size: 12px;
        color: $--base-color-black;
        &:last-child {
          padding-left: 8px;
        }
      }
    }
  }
}

</style>
